import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // useLayoutEffect is generally preferred here for immediate scroll before browser paint
  useLayoutEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner of the page
  }, [pathname]); // This effect runs whenever the pathname (route) changes

  return null; // This component doesn't render anything visible
};

export default ScrollToTop;